import {
  clearCollectionEvent,
  findEventToStart,
  getCollectionEventRewardProgress,
  getCurrentEventInstance,
  getRewardConfig,
  startEvent,
} from './collectionEventUtils';
import type { CollectionEventProgressBarView } from '../views/CollectionEventProgressBarView';
import type { CollectionEventDependencies } from '../CollectionEventController';
import type { CollectionEventConfig } from '../types';
import { openCollectionEventPopup } from './openCollectionEventPopup';
import { getTimeLimitHandler } from '../../../libs/timeLimit/getTimeLimitHandler';

async function startRewardFlow(
  dependencies: CollectionEventDependencies,
  eventInstance: CollectionEventConfig,
  progressBarView: CollectionEventProgressBarView | null,
): Promise<void> {
  if (eventInstance.tokensLastSeen === eventInstance.tokensCollected) return;

  const lastReward = getCollectionEventRewardProgress(eventInstance, eventInstance.tokensLastSeen);
  const currentReward = getCollectionEventRewardProgress(eventInstance, eventInstance.tokensCollected);

  await progressBarView?.playProgressAnimation?.(currentReward);

  if (currentReward.rewardIndex !== lastReward.rewardIndex) {
    for (let i = lastReward.rewardIndex; i < currentReward.rewardIndex; i += 1) {
      dependencies.addResource(
        {
          eventId: `${eventInstance.id}_${eventInstance.timeLimit.startedAt ?? 0}`,
          tokens: eventInstance.tokensCollected,
        },
        getRewardConfig(eventInstance, i).rewards,
      );
    }
  }

  eventInstance.tokensLastSeen = eventInstance.tokensCollected;

  dependencies.observable.updateValue({
    collectionEvent: {
      ...dependencies.observable.getValue().collectionEvent,
      currentEvent: eventInstance,
    },
  });
}

export async function startCollectionEventMenuFlow(
  dependencies: CollectionEventDependencies,
  progressBarView: CollectionEventProgressBarView | null,
): Promise<void> {
  const eventInstance = getCurrentEventInstance(dependencies);

  if (progressBarView && eventInstance) {
    await startRewardFlow(dependencies, eventInstance, progressBarView);
  }

  if (!eventInstance || getTimeLimitHandler(eventInstance.timeLimit).hasEnded()) {
    if (eventInstance && getTimeLimitHandler(eventInstance.timeLimit).hasEnded()) {
      clearCollectionEvent(dependencies);
    }

    const newEventToStart = findEventToStart(dependencies);
    if (!newEventToStart) return;
    startEvent(dependencies, newEventToStart);
    await openCollectionEventPopup(dependencies, true);
  }
}
